// MenuOffer.tsx
import React, {useEffect, useRef} from 'react';
import {gsap} from 'gsap';
import {ScrollTrigger} from 'gsap/ScrollTrigger';
import styles from './MenuOffer.module.css';
import stylesShare from '../../components/fields/shared/shareModuleStyle.module.css';

gsap.registerPlugin(ScrollTrigger);

const MenuOffer = (props) => {
    const {subtitle, title,desccription} = props;
    const sectionRef = useRef(null);
    const titleRef = useRef(null);

    useEffect(() => {
        const ctx = gsap.context(() => {
            // Background particles animation
            gsap.to(sectionRef.current, {
                backgroundPosition: "50% 100%",
                duration: 40,
                repeat: -1,
                ease: "none"
            });
        }, sectionRef);

        return () => ctx.revert();
    }, []);


    return (
        <section ref={sectionRef} className={styles.menuSection}>
            <div ref={titleRef} className={`${styles.sectionTitle} ${styles.shine}`}>
                {subtitle}
            </div>
            <div className={stylesShare.decorativeLine}>
                <img src="/assets/icons/headerline.png" alt="decorative line"/>
            </div>
            <div className={stylesShare.heading}>
                <h2 className={stylesShare.headingText}>{title}</h2>

            </div>
            <div>
                {desccription}
            </div>
        </section>

    );
};

export default MenuOffer;